import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneWebsiteUpdateInfo from './submodules/clone';
import CreateWebsiteUpdateInfo from './submodules/create';
import ListWebsiteUpdateInfo from './submodules/list';
import EditWebsiteUpdateInfo from './submodules/edit';

const WebsiteUpdateDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getWebsiteUpdates]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListWebsiteUpdateInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addWebsiteUpdateInfo]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneWebsiteUpdateInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addWebsiteUpdateInfo]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateWebsiteUpdateInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].updateWebsiteUpdateInfo]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditWebsiteUpdateInfo}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default WebsiteUpdateDashboard;
